import CityPageTemplate from "../city-template/CityPageTemplate";
import { collegeParkConfig } from "./data";

export default function CollegeParkPage() {
  return <CityPageTemplate config={collegeParkConfig} />;
}